import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_edit_dash_black.svg'
import _imports_1 from '@/app/ui/assets/svg/trash-red.svg'


const _hoisted_1 = { class: "flex items-center gap-2.5 rounded-xl border border-gray-lp-1600 bg-white px-3 py-3" }
const _hoisted_2 = { class: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-lp-1000 text-16px font-semibold text-black-lp-200" }
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = {
  key: 0,
  class: "rounded bg-yellow-lp-200 px-1 py-0.5 text-center text-xs font-medium text-yellow-lp-100"
}
const _hoisted_5 = {
  key: 1,
  class: "rounded bg-red-lp-600 px-1 py-0.5 text-center text-xs font-medium text-red-lp-1600"
}
const _hoisted_6 = { class: "text-16px font-semibold normal-case text-black-lp-100" }
const _hoisted_7 = { class: "flex-1 text-14px font-medium text-gray-lp-800" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-5 w-5",
  alt: "edit"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "h-5 w-5",
  alt: "delete"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.index), 1),
    _createVNode("div", _hoisted_3, [
      (_ctx.savedPackage.isQuarantine)
        ? (_openBlock(), _createBlock("span", _hoisted_4, " K "))
        : _createCommentVNode("", true),
      (_ctx.savedPackage.isDangerousGoods)
        ? (_openBlock(), _createBlock("span", _hoisted_5, " DG "))
        : _createCommentVNode("", true),
      _createVNode("span", _hoisted_6, _toDisplayString(_ctx.displayName), 1)
    ]),
    _createVNode("div", _hoisted_7, _toDisplayString(_ctx.savedPackage.totalPieces) + " " + _toDisplayString(_ctx.$t('managementCustomer.savedPackage.koli')) + " • " + _toDisplayString(_ctx.savedPackage.totalGrossWeight) + " kg ", 1),
    (_ctx.editable)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("button", {
            type: "button",
            class: "flex h-5 w-5 items-center justify-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit')))
          }, [
            _hoisted_9
          ]),
          _createVNode("button", {
            type: "button",
            class: "flex h-5 w-5 items-center justify-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete')))
          }, [
            _hoisted_10
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}